import CreateGroup from './component'

export default CreateGroup
